import styled from '@emotion/styled'
import { ClaimStatusCodeEnum } from '../../HealthClaimPage/ClaimHandlingTable/types'

const handleDisplayPolicyStatusColor = ({
  status,
  property,
}: {
  status: ClaimStatusCodeEnum
  property: string
}) => {
  const colorSet = {
    [ClaimStatusCodeEnum.IN_REVIEW]: {
      background: '#E2F2FF',
      color: '#276EF1',
    },
    [ClaimStatusCodeEnum.SUBMITTED]: {
      background: '#E2F2FF',
      color: '#276EF1',
    },
    [ClaimStatusCodeEnum.REJECTED_ON_PV]: {
      background: '#FDE7E6',
      color: '#EF2605',
    },
    [ClaimStatusCodeEnum.REJECTED]: {
      background: '#FDE7E6',
      color: '#EF2605',
    },
    [ClaimStatusCodeEnum.DOCUMENTS_REQUESTED]: {
      background: '#FFF8E0',
      color: '#FFA100',
    },
    [ClaimStatusCodeEnum.PENDING_APPROVAL]: {
      background: '#F4F3FF',
      color: '#5925DC',
    },
    [ClaimStatusCodeEnum.PENDING_PAYMENT]: {
      background: '#E6F6EA',
      color: '#009640',
    },
    [ClaimStatusCodeEnum.CREATE_PAYMENT]: {
      background: '#E6F6EA',
      color: '#009640',
    },
    [ClaimStatusCodeEnum.PENDING_DOCUMENT]: {
      background: '#FDE7E6',
      color: '#EF2605',
    },
    [ClaimStatusCodeEnum.COMPLETED]: {
      background: '#E9EBEF',
      color: '#666666',
    },
    [ClaimStatusCodeEnum.APPROVED]: {
      background: '#E6F6EA',
      color: '#009640',
    },
  }
  return colorSet[status][property]
}

export const ClaimFormStatusTagStyle = styled('div')<{
  status: any
}>`
  background: ${(props) =>
    handleDisplayPolicyStatusColor({
      status: props.status,
      property: 'background',
    })};
  box-sizing: border-box;
  border-radius: 100px;
  font-size: 12px;
  line-height: 14px;
  color: ${(props) =>
    handleDisplayPolicyStatusColor({
      status: props.status,
      property: 'color',
    })};
  display: flex;
  justify-content: center;
  padding: 6px 12px;
`
